import { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import { messages } from './messages';
import { ColorPropertyInput } from '../color-property-input';

import type { TextWidget, WidgetPropertyInput, WidgetPropertyDefinition } from '../../../config';

const FontColor = memo(({ widget, updateWidget, ...rest }: WidgetPropertyInput<TextWidget>) => (
  <ColorPropertyInput updateWidget={(color) => updateWidget({ fontColor: color })} value={widget.fontColor} {...rest} />
));

export const FontColorProperty: WidgetPropertyDefinition<TextWidget> = {
  id: 'font-color',
  label: <FormattedMessage {...messages.label} />,
  Component: FontColor,
};
